import { render, staticRenderFns } from "./addBoxofficeRecord.vue?vue&type=template&id=fb350370&scoped=true&"
import script from "./addBoxofficeRecord.vue?vue&type=script&lang=js&"
export * from "./addBoxofficeRecord.vue?vue&type=script&lang=js&"
import style0 from "./addBoxofficeRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addBoxofficeRecord.vue?vue&type=style&index=1&id=fb350370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb350370",
  null
  
)

export default component.exports